import React, { useState } from 'react';
import { XIcon, PackageIcon, TruckIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
interface OrderTrackingModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function OrderTrackingModal({
  isOpen,
  onClose
}: OrderTrackingModalProps) {
  const [step, setStep] = useState<'input' | 'otp' | 'tracking'>('input');
  const [orderNumber, setOrderNumber] = useState('');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!orderNumber || !phone) {
      setError('Please fill in all fields');
      return;
    }
    setError('');
    setStep('otp');
  };
  const handleOtpChange = (index: number, value: string) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };
  const handleVerifyOtp = () => {
    const otpValue = otp.join('');
    if (otpValue.length === 6) {
      setStep('tracking');
    }
  };
  const handleReset = () => {
    setStep('input');
    setOrderNumber('');
    setPhone('');
    setOtp(['', '', '', '', '', '']);
    setError('');
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-[200] flex items-center justify-center p-4" data-id="element-4304" data-mp="27x3khm6thpql">
      <div className="bg-white rounded-xl max-w-md w-full max-h-[90vh] overflow-y-auto relative z-[201]" data-id="element-4305" data-mp="22ztkxdpprxp1">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200" data-id="element-4306" data-mp="1yzjgi5hklfca">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-4307" data-mp="1u0pyq0v9326b">Track Your Order</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" data-id="element-4308" data-mp="nk4h6v1w2be0">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-4309" data-mp="k0m5zql8nv3i" />
          </button>
        </div>
        {/* Content */}
        <div className="p-6" data-id="element-4310" data-mp="ozgmumznb9kz">
          {step === 'input' && <form onSubmit={handleSubmit} className="space-y-6" data-id="element-4311" data-mp="oxmd84ttr3w7">
              <div data-id="element-4312" data-mp="ayw7y1wupxwr">
                <label htmlFor="orderNumber" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4313" data-mp="azo0t4z2dhjc">
                  Order Number
                </label>
                <input type="text" id="orderNumber" value={orderNumber} onChange={e => setOrderNumber(e.target.value)} placeholder="e.g., ORD-12345" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-4314" data-mp="181h0k8nua4z" />
              </div>
              <div data-id="element-4315" data-mp="3jg91zzlgf6bw">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-4316" data-mp="3jepk64k5gn80">
                  Phone Number
                </label>
                <input type="tel" id="phone" value={phone} onChange={e => setPhone(e.target.value)} placeholder="+966 5X XXX XXXX" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-4317" data-mp="2uvw6l4hv1flr" />
              </div>
              {error && <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg" data-id="element-4318" data-mp="3drw1oo64wz9k">
                  <AlertCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0" data-id="element-4319" data-mp="3njjo2anu3q46" />
                  <p className="text-sm text-red-600" data-id="element-4320" data-mp="3nlmn1k6ystl1">{error}</p>
                </div>}
              <button type="submit" className="w-full bg-[#1E2B55] text-white font-bold py-3 rounded-lg hover:bg-[#162041] transition-colors" data-id="element-4321" data-mp="5bkiouyjsdc5">
                Continue
              </button>
            </form>}
          {step === 'otp' && <div className="space-y-6" data-id="element-4322" data-mp="1zrsmz26lvk28">
              <div className="text-center" data-id="element-4323" data-mp="24klu1wpjr4hh">
                <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-4324" data-mp="24myk6x5gkl5m">
                  <PackageIcon className="w-8 h-8 text-[#1E2B55]" data-id="element-4325" data-mp="28oa02ayj5s0m" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-4326" data-mp="1by9hwuso29sa">
                  Enter Verification Code
                </h3>
                <p className="text-sm text-gray-600" data-id="element-4327" data-mp="1kwd1hlk3cwhg">
                  We sent a 6-digit code to {phone}
                </p>
              </div>
              <div className="flex justify-center gap-2" data-id="element-4328" data-mp="1pxiuzllksns1">
                {otp.map((digit, index) => <input key={index} id={`otp-${index}`} type="text" maxLength={1} value={digit} onChange={e => handleOtpChange(index, e.target.value)} className="w-12 h-12 text-center text-xl font-bold border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent" data-id="element-4329" data-mp="2wbrxon4h7kbi" data-mpi={index} />)}
              </div>
              <button onClick={handleVerifyOtp} disabled={otp.join('').length !== 6} className="w-full bg-[#1E2B55] text-white font-bold py-3 rounded-lg hover:bg-[#162041] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-4330" data-mp="2xltynf1c7swq">
                Verify & Track Order
              </button>
              <button onClick={() => setStep('input')} className="w-full text-sm text-gray-600 hover:text-[#1E2B55]" data-id="element-4331" data-mp="2eq3t5hu74ee3">
                Change phone number
              </button>
            </div>}
          {step === 'tracking' && <div className="space-y-6" data-id="element-4332" data-mp="26f3glo7m1vi3">
              <div className="text-center pb-6 border-b border-gray-200" data-id="element-4333" data-mp="26e1xqxkcs4pt">
                <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-4334" data-mp="2b8frywna45sw">
                  <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-4335" data-mp="1xddg7svr3m86" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-4336" data-mp="21hbek1d94t06">
                  Order {orderNumber}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-4337" data-mp="2u5qq2dx6ct6r">
                  Expected delivery: Tomorrow, 2:00 PM - 5:00 PM
                </p>
              </div>
              {/* Tracking Timeline */}
              <div className="space-y-4" data-id="element-4338" data-mp="2l50xrk74hkxs">
                <div className="flex gap-4" data-id="element-4339" data-mp="2l3zkd92mwmcw">
                  <div className="flex flex-col items-center" data-id="element-4340" data-mp="2l6vmzapffz7o">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-4341" data-mp="14p7ub2synr6r">
                      <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-4342" data-mp="19r6yug0fsu5a" />
                    </div>
                    <div className="w-0.5 h-full bg-green-200 my-2" data-id="element-4343" data-mp="11720duylbmie"></div>
                  </div>
                  <div className="flex-1 pb-6" data-id="element-4344" data-mp="x708gdinq7gb">
                    <h4 className="font-semibold text-gray-900" data-id="element-4345" data-mp="1b7ks1bwec7av">
                      Order Confirmed
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-4346" data-mp="168znx1e0x3h5">
                      Your order has been received
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-4347" data-mp="igaux4hq4g9a">
                      Jan 15, 2024 - 10:30 AM
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4348" data-mp="s9rny6a1drbw">
                  <div className="flex flex-col items-center" data-id="element-4349" data-mp="nhglowrtptg6">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-4350" data-mp="ng5k93luoxs8">
                      <CheckCircleIcon className="w-6 h-6 text-green-600" data-id="element-4351" data-mp="3vv76caybmhkl" />
                    </div>
                    <div className="w-0.5 h-full bg-green-200 my-2" data-id="element-4352" data-mp="3qw2vzgznudso"></div>
                  </div>
                  <div className="flex-1 pb-6" data-id="element-4353" data-mp="35gyqvz06p4v2">
                    <h4 className="font-semibold text-gray-900" data-id="element-4354" data-mp="3ad5moyyv8zza">Processing</h4>
                    <p className="text-sm text-gray-600" data-id="element-4355" data-mp="3fdbj0sg2zanp">
                      Your order is being prepared
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-4356" data-mp="3kd66sn4k7k4j">
                      Jan 15, 2024 - 11:00 AM
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4357" data-mp="3tcb5btg4fdgp">
                  <div className="flex flex-col items-center" data-id="element-4358" data-mp="3tb03w0a5ehsr">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center animate-pulse" data-id="element-4359" data-mp="1xvow320egxb">
                      <TruckIcon className="w-6 h-6 text-blue-600" data-id="element-4360" data-mp="6vx9isf32oaw" />
                    </div>
                    <div className="w-0.5 h-full bg-gray-200 my-2" data-id="element-4361" data-mp="bxmim2iqwrwc"></div>
                  </div>
                  <div className="flex-1 pb-6" data-id="element-4362" data-mp="fypz8r8marym">
                    <h4 className="font-semibold text-gray-900" data-id="element-4363" data-mp="20fz5saxg7ngh">
                      Out for Delivery
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-4364" data-mp="1we461av61i4t">
                      Your order is on the way
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-4365" data-mp="1rfsw704vf7ml">
                      Jan 16, 2024 - 9:00 AM
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-4366" data-mp="2k47xykyzrtfz">
                  <div className="flex flex-col items-center" data-id="element-4367" data-mp="2k613ty1s69mx">
                    <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center" data-id="element-4368" data-mp="2f5wqggw65v0x">
                      <CheckCircleIcon className="w-6 h-6 text-gray-400" data-id="element-4369" data-mp="2acu16kyfd7qj" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-4370" data-mp="25cxyqq5dlod3">
                    <h4 className="font-semibold text-gray-400" data-id="element-4371" data-mp="32uy2sf84hqbh">Delivered</h4>
                    <p className="text-sm text-gray-400" data-id="element-4372" data-mp="2y3pslgyyy0x9">
                      Order will be delivered soon
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex gap-3 pt-4 border-t border-gray-200" data-id="element-4373" data-mp="2xn2qzkvyegs6">
                <button onClick={handleReset} className="flex-1 border-2 border-[#1E2B55] text-[#1E2B55] font-medium py-3 rounded-lg hover:bg-[#F1F2F6] transition-colors" data-id="element-4374" data-mp="2xovxn06kh106">
                  Track Another Order
                </button>
                <button onClick={onClose} className="flex-1 bg-[#1E2B55] text-white font-medium py-3 rounded-lg hover:bg-[#162041] transition-colors" data-id="element-4375" data-mp="3ljfi6u8n8el3">
                  Close
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}